// eslint-disable-next-line max-len
import { GlobalDefaultSetting } from '../modules/admin/components/shared/components/global-default-settings/models/global-default-setting.model';
import { ActionSetting } from '../services/dtos/actionSetting';
import { PluginSetting } from '../services/dtos/pluginSetting';
import { ListItemFilter } from './components/local-types/ListItemFilter';

export class Utils {
  public static getLabelForClose(isEditMode: boolean): string {
    return isEditMode ? 'Cancel' : 'Close';
  }

  public static mapGlobalDefaultSettingToListItem(
    globalDefaultSettings: GlobalDefaultSetting[]
  ): ListItemFilter[] {
    return globalDefaultSettings.map((x, index) => ({
      id: index++,
      name: x.key,
    })) as ListItemFilter[];
  }

  public static mapGlobalDefaultSettingsToPluginSettings(globalDefaultSettings: GlobalDefaultSetting[]): PluginSetting[] {
    return globalDefaultSettings.map((x) => ({
      id: x.id,
      key: x.key,
      value: x.value
    })) as PluginSetting[];
  }

  public static mapGlobalDefaultSettingsToActionSettings(globalDefaultSettings: GlobalDefaultSetting[]): ActionSetting[] {
    return globalDefaultSettings.map((x) => ({
      id: x.id,
      key: x.key,
      value: x.value,
      displayName: '',
      settingType: '',
      typeValues: [],
      isSensitive: false,
      moveNextSettingToNewLine: false,
      columnsAmount: 0
    })) as ActionSetting[];
  }
}
